import React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { MdMenuBook } from "react-icons/md";
import { RiBookletLine } from "react-icons/ri";
import { FaCheckCircle } from "react-icons/fa";
import { FaRocket } from "react-icons/fa";

const AddNew = () => {
  const navigate = useNavigate();
  const { moduleId } = useParams();
  const [searchParams] = useSearchParams();
  const courseId = searchParams.get('courseId');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-300 via-purple-300 to-pink-300 px-4 py-10">
      <div className="bg-white/30 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/40 max-w-xl w-full p-8">
        <div className="text-center mb-8">
          <FaRocket className="text-5xl text-purple-700 mx-auto animate-bounce" />
          <h1 className="text-3xl font-bold text-purple-900 mt-4 font-montserrat">
            What would you like to add?
          </h1>
          <p className="text-purple-800 mt-2">
            Boost your course with new modules and chapters!
          </p>
        </div>

        <div className="space-y-4">
          <Tooltip title="Add a new chapter to this module">
            <button
              onClick={() => navigate(`/chapter/${moduleId}`)}
              className="w-full flex items-center justify-center gap-3 bg-gradient-to-r from-indigo-500 to-purple-600 hover:to-purple-700 text-white font-semibold py-3 rounded-xl shadow-lg hover:scale-105 transition transform"
            >
              <MdMenuBook className="text-2xl" />
              Add Chapter
            </button>
          </Tooltip>

          <Tooltip title="Add a new module to the course">
            <button
              onClick={() => navigate(`/module?courseId=${courseId}`)}
              className="w-full flex items-center justify-center gap-3 bg-gradient-to-r from-orange-400 to-pink-500 hover:to-pink-600 text-white font-semibold py-3 rounded-xl shadow-lg hover:scale-105 transition transform"
            >
              <RiBookletLine className="text-2xl" />
              Add Module
            </button>
          </Tooltip>

          <Tooltip title="Mark course as finished and return">
            <button
              onClick={() => navigate(`/module-list/${courseId}`)}
              className="w-full flex items-center justify-center gap-3 bg-gradient-to-r from-green-500 to-teal-500 hover:to-teal-600 text-white font-semibold py-3 rounded-xl shadow-lg hover:scale-105 transition transform"
            >
              <FaCheckCircle className="text-2xl" />
              Finish Course
            </button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default AddNew;
